<template>
  <button
    :id="btnAddItem"
    @click="$emit('add-order', product)"
    :disabled="isClose" v-tooltip.top="productName"
    class="group relative bg-cream/50 border border-gray-200 dark:border-dark-800 dark:bg-dark-700 shadow-sm hover:shadow-md rounded-lg overflow-hidden transition-all duration-200 flex flex-col h-42 w-full text-left active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
    :class="{ 'opacity-50 cursor-not-allowed': isClose }"
  >
    <!-- Image Section -->
    <div class="relative h-24 bg-white dark:bg-dark-800  w-full">
      <div
        v-if="product.monitor_stock"
        class="absolute top-2 left-2 px-2 py-0.5 text-xs rounded-full capitalize"
        :class="{
          'bg-danger/90 text-white': product.stock <= 0,
          'bg-warning/90 text-black': product.stock > 0 && product.stock < 5,
          'bg-green-500/90 text-white': product.stock >= 5
        }"
        v-tooltip.top="product.stock"
      >
        {{ product.stock }}
      </div>
      <img
        v-if="product.image"
        :src="product.image"
        :alt="productName"
        class="w-full h-full object-cover"
      />
      <div
        v-else
        class="w-full h-full flex items-center justify-center text-primary/50 dark:text-primary/30"
      >
        <PhotoIcon class="w-full h-full" />
      </div>
      <!-- Menu Type Badge -->
      <div
        class="absolute top-2 right-2 px-2 py-0.5 text-xs rounded-full capitalize bg-danger/30 text-primary dark:bg-danger/20 dark:text-dark-50"
      >
        {{ product.itemCategory?.name }}
      </div>
    </div>

    <!-- Content Section -->
    <div class="flex flex-col flex-grow p-3 w-full">
      <!-- Product Code -->
      <!-- <p class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">
                {{ product.code }}
            </p> -->

      <!-- Product Name -->
      <div class="min-h-[2.5rem] flex items-center">
        <h3
          class="font-semibold tracking-wide text-primary dark:text-dark-50 text-base line-clamp-2 break-words w-full"
        >
          {{ productName }}
        </h3>
      </div>
      <div v-if="product.has_product_mix" class="mt-1 w-full">
        <span class="inline-block dark:bg-green-900/30 text-success dark:text-green-300 text-xs px-2 py-0.5 line-clamp-1 w-full overflow-hidden text-ellipsis">
          {{ product.product_mix?.map(mix => mix.name).join(', ') }}
        </span>
      </div>

      <!-- Price -->
      <div class="mt-auto w-full">
        <div class="flex items-center justify-between w-full">
          <p class="text-primary dark:text-dark-50 font-medium" :class="{ 'line-through text-gray-500 dark:text-gray-400': product.discount_price > 0 }">
            {{ productPrice }}
          </p>
          <p v-if="product.discount_price > 0" class="text-green-600 dark:text-green-400 font-medium">
            {{ formatPrice(parseFloat(product.sale_price) - parseFloat(product.discount_price)) }}
          </p>
        </div>
        <div v-if="product.max_qty > 0" class="flex items-center justify-start w-full">
          <p class="text-gray-500 dark:text-gray-400 text-xs">
            Maksimal Jumlah : {{ product.max_qty }}
          </p>
        </div>
        <!-- <div class="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 mt-1">
                    <span>Unit: {{ product.unit_id }}</span>
                    <span v-if="product.discount_price > 0" class="text-green-600 dark:text-green-400">
                        Disc: {{ formatPrice(product.discount_price) }}
                    </span>
                </div> -->
      </div>
    </div>
  </button>
</template>

<script>
import { PhotoIcon } from "@heroicons/vue/24/outline";

export default {
  name: "ProductCard",
  components: {
    PhotoIcon,
  },
  props: {
    productName: {
      type: String,
      required: true,
    },
    productPrice: {
      type: String,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    btnAddItem: {
      type: String,
      required: true,
    },
    isClose: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    },
  },
};
</script>
